/** @format */

import { SanitizedSEOAttributes } from './sanitized-seo-attributes.interface';
import { SEOCategoryDetails } from './seo-category-details-response.interface';
import { PrunedSEOCategoryDetails } from './pruned-seo-category-details.interface';

export interface MappedAttributesFields {
  sanitizedAttributes?: SanitizedSEOAttributes;
}

export type ProductListSEO = SEOCategoryDetails & MappedAttributesFields;

export type PrunedProductListSEO = PrunedSEOCategoryDetails & MappedAttributesFields;

export interface ProductListSEOResponse {
  categories: ProductListSEO[];
}
